<template>
    <div class="py-4">
        <modal-cancel v-if="oncancel" :oncancel="oncancel" :state="state" :id="id" @onclose="oncancel = false" @onreload="$router.go()" />
        <header>
            <div class="container-fluid">
                <div class="pb-4">
                    <div class="row align-items-end">
                        <div class="col-sm col-12">
                            <h1 class="h2 ls-tight">Factura</h1>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main>
            <div class="container-fluid">
                <div class="vstack gap-4">
                    <div class="card" v-if="loading == false && id">
                        <div class="card-header bg-white d-flex align-items-center justify-content-between">
                            <h5 class="me-auto">{{ state == 23 ? 'Factura Reembolsada' : state == 28 ? 'Factura Anulada' : 'Factura' }}</h5>
                            <button @click="NOTE_CREDIT()" v-if="state == 24 && globalViewOption('ReimburseInvoice')" class="btn btn-danger btn-h mr-3">
                                <small class="d-flex justify-content-center align-items-center">
                                    Reembolsar factura
                                </small>
                            </button>
                            <button @click="NOTE_CREDIT()" v-if="state != 28 && state != 24 && globalViewOption('CancelInvoice')" class="btn btn-danger btn-h mr-3">
                                <small class="d-flex justify-content-center align-items-center">
                                    Anular factura
                                </small>
                            </button>
                            <button @click="PRINT()" class="btn btn-neutral btn-m">
                                <small class="d-flex justify-content-center align-items-center">
                                    <i class="bi bi-printer"></i>
                                </small>
                            </button>
                        </div>
                        <div class="card-body p-0">
                            <billing :print="false"/>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
import Billing from './forms/invoice/Billing';
import ModalCancel from './modals/Cancel'
export default {
    components: { Billing, ModalCancel },
    data(){
        return{
            data: {},
            id: '',
            oncancel: false,
            state: '',
            loading: true
        }
    },
    created(){
        let vue = this
        vue.INIT()
    },
    methods: {
        INIT: function () {
            let vue = this
            vue.loading = true
            axios({ url: '/packages/' + this.$route.params.id + '/invoice', method: 'GET' })
                .then((resp) => {
                    vue.data = resp.data
                    vue.state = vue.data.state_id
                    vue.id = vue.data.id
                })
                .catch((err) => {
                   let message = err.response ? err.response.data.message : err.message
                    vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    vue.$router.push({ name: 'PackageIndex' })
                })
                .finally((resp) => {
                    vue.loading = false
                })
        },
        PRINT(){
            document.getElementById("print-iframe").contentWindow.print();
        },
        NOTE_CREDIT(){
            this.oncancel = true
        }
    }
}
</script>